import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import theme from "@/styles/theme";
import { Box, Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const Wrapper = styled(Center)``;

export const CustomBox = styled(Box)`
    position: relative;
`;

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 20, 700)}
`;

interface CustomLocalNavBarProps {
    isExceedRoomAmountOfTen?: boolean;
}

export const CustomLocalNavBar = styled(Center)<CustomLocalNavBarProps>`
    position: absolute;
    opacity: 0;
    visibility: hidden;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: ${({ isExceedRoomAmountOfTen }) => (isExceedRoomAmountOfTen ? "528px" : "176px")};
    transition: 1s cubic-bezier(0.215, 0.61, 0.355, 1);
    display: ${({ isExceedRoomAmountOfTen }) => (isExceedRoomAmountOfTen ? "grid" : "flex")};
    grid-template-columns: ${({ isExceedRoomAmountOfTen }) => (isExceedRoomAmountOfTen ? "repeat(2,1fr)" : "")};

    &.on {
        opacity: 1;
        top: 65px;
        visibility: visible;
    }

    &.off {
        opacity: 0;
        top: 120px;
        visibility: hidden;
    }

    & > p:nth-of-type(odd) {
        ${({ isExceedRoomAmountOfTen }) =>
            isExceedRoomAmountOfTen
                ? `
            border-right:1px solid ${theme.COLOR.bgColor[100]}
            `
                : ""}
    }
`;

export const CustomText = styled(Text)`
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.bgColor[200]};
    ${FONT("pretendard", 14, 300)}
    border-bottom:1px solid ${({ theme }) => theme.COLOR.bgColor[100]};

    &:hover {
        background: ${({ theme }) => theme.COLOR.bgColor[300]};
    }
`;

export const CustomButton = styled(Button)`
    ${FONT("pretendard", 16, 300)}
`;
